var MergeInstructor = {
  init: function() {
    this.assign_event_handlers();
    this.init_instructor_search();
  },
  assign_event_handlers: function() {
    // console.log("Assigning event handlers for MergeInstructor");
  },
  init_instructor_search: function() {
    $("#instructor-search").autocomplete({
      serviceUrl: '/admin/instructors/search',
      dataType: 'json',
      minChars: 3,
      formatResult: function(suggestion, currentValue) {
        return suggestion.value.replace(currentValue, ('<strong>' + currentValue + '</strong>'));
      },
      onSelect: function(suggestion) {
        MergeInstructor.set_instructor(suggestion.data['sfid']);
      }
    });
  },
  set_instructor: function(instructor_sfid) {
    var frm_acc = $('[name="to_account"]');
    $(frm_acc).val(instructor_sfid);
  }
}

document.addEventListener("turbo:load", () => {
  if ($('.instructor-show-page')[0]) {
    MergeInstructor.init();
  }
});
